import { Injectable } from '@angular/core';
import { TaskWorkspaceState } from '../../../h3ml/state/task-workspace-state';
import { AbstractChangeOperationService } from './abstract-change-operation.service';
import { TaskOperationBuilderParams } from './operation-builders/task-operation-builder-params';
import { UpdateNextObjectClassOperationBuilder } from './operation-builders/update-next-object-class-operation-builder';
import { UpdateNextObjectIdOperationBuilder } from './operation-builders/update-next-object-id-operation-builder';
import { UpdateNextShapeIdOperationBuilder } from './operation-builders/update-next-shape-id-operation-builder';

@Injectable()
export class TaskChangeOperationService extends AbstractChangeOperationService<TaskOperationBuilderParams> {
  protected override getEntries(
    previous: TaskWorkspaceState,
    current: TaskWorkspaceState,
  ): TaskOperationBuilderParams[] {
    return [{ previousTask: previous, currentTask: current }];
  }

  protected override createBuilders(entry: TaskOperationBuilderParams) {
    return [
      new UpdateNextShapeIdOperationBuilder(entry),
      new UpdateNextObjectIdOperationBuilder(entry),
      new UpdateNextObjectClassOperationBuilder(entry),
    ];
  }
}
